import { z } from "zod";
import { assignmentSchema, assignmentsPageSchema, assignmentVersionSchema } from "./api.generated";

// Response validators are generated from the operations contract; the requirement vocabulary derives from them.
export { assignmentSchema, assignmentsPageSchema, assignmentVersionSchema };
/** A requirement the console may write: an assurance floor, or null to remove access. */
export const editableRequirementSchema = assignmentSchema.shape.minimum_assurance;
export const assignmentWriteSchema = z.object({
  version: z.number().int().nonnegative(),
  minimum_assurance: editableRequirementSchema,
});
export const applicationAccessSearchSchema = z.object({
  appCursor: z.string().uuid().optional(),
});
export type ApplicationAssignment = z.infer<typeof assignmentSchema>;
export type AssignmentWrite = z.infer<typeof assignmentWriteSchema>;
export type AssignmentVersion = z.infer<typeof assignmentVersionSchema>;
export const requirementLabels = {
  authenticated: "Any enabled sign-in method",
  phishing_resistant: "Verified passkey",
  approved_federation: "Customer identity provider required",
} as const satisfies Record<NonNullable<z.infer<typeof editableRequirementSchema>>, string>;
